<template>
  <Modal
    class="quickModal"
    v-model="modalshow" 
    width="1200" 
    :transfer="false"
  > 
    <div class="modalbody mt-5">
      <Row>
        <Col span="6">
          <div class="btnArea">
            <Button type="success" class="mr-1" @click="selectAllBtn()">{{ $t("report.selectAll") }}</Button>
            <Button type="error" @click="clearAllBtn()">{{ $t("report.deleteAll") }}</Button>
          </div>
          <Row>
            <Col span="13">
              <div class="numArea">
                <Row>
                  <Col class="col-xs-15" v-for="(i,index) in 5" :key="i">
                    <button :class="['numbutton', {'focus': it.focus}]" v-for="it in balls[index]" :key="it.id" @click="it.focus = !it.focus, numSelect(it.value)">
                      <span class="text-center" :class="it.color+'-text'">
                        {{it.id}}
                      </span>
                    </button>
                  </Col>
                </Row>
                <Row>
                  <Col class="col-xs-15" v-for="(i, index) in 5" :key="i">
                    <button :class="['numbutton', {'focus': it.focus}]" v-for="it in zodiac[index]" :key="it.id" @click="it.focus = !it.focus, zodiacSelect(it.value, it.focus)">
                      <span class="text-center">
                        {{it.id}}
                      </span>
                    </button>
                  </Col>
                </Row>
                <Row>
                  <Col class="col-xs-15" v-for="(i, index) in 5" :key="i">
                    <button :class="['numbutton', {'focus': it.focus}]" v-for="it in tail[index]" :key="it.id" @click="it.focus = !it.focus, tailSelect(it.value)">
                      <span class="text-center">
                        {{it.id}}
                      </span>
                    </button>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span="11">
              <div class="modArea">
                <Select v-model="mod" style="width: 95px">
                  <Option value="zodiac">{{ $t("lsib.ShengShiau") + $t("common.mode") }}</Option>
                  <Option value="twoside">{{ $t("lsib.LiangMian") + $t("common.mode") }}</Option>
                </Select>
                <br />
                <CheckboxGroup class="modCheckboxGroup mt-2" v-model="selectAry" @on-change="modCheckboxChange">
                  <Row>
                    <Col class="mb-1" v-for="(i, index) in (this.mod == 'zodiac' ? 7 : 3)" :key="i">
                      <Checkbox v-for="it in modlist[mod][index]" :key="it.value" :label="it.value">{{ it.id }}</Checkbox>
                    </Col>
                  </Row>
                </CheckboxGroup>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span="18">
          <div class="rightbtnArea">
            <div>
              <span class="ml-1">{{'比例模板'}}</span>
              <Select v-model="tempId" class="ml-1" style="width: 150px" @on-change="setTempData()">
                <Option v-for="item, ind in templist" :value="item.modid" :key="item.id">
                  <Icon v-if="templist.length == ind+1" type="md-add-circle" />{{ item.name }}
                </Option>
              </Select>
              <template v-if="tempId == 0">
                <span class="modaltext ml-1">{{'新模板名称'}}</span>
                <Input type="text" class="ml-1" style="width: 150px" v-model="newtempName" maxlength="8" placeholder="请输入新模板名称" />
              </template>
              <span class="ml-1 red-text">＊比例将以原始赔率调整</span>
              <Button v-if="![1].includes(tempId)" class="ml-1" type="primary" @click="savetemp()" :disabled="deletmpState">{{'储存模板'}}</Button>
              <Button v-if="![0, 1].includes(tempId)" class="ml-1" type="error" @click="deletemp()" :disabled="deletmpState">{{'删除模板'}}</Button>
            </div>
            <Button @click.stop="page = page == 0 ? 1 : 0">
              <span :class="[ page == 0 ? 'dark-text' : 'grey-text' ]">{{ '第一页' }}</span>
              <Icon class="mx-1" type="md-swap" />
              <span :class="[ page !== 0 ? 'dark-text' : 'grey-text' ]">{{ '第二页' }}</span>
            </Button>
          </div>
          <div class="tableArea">
            <Row>
              <template v-for="key in 2">
                <template v-for="(arry, ind) in pmTable[key-1]">
                  <Col v-show="key-1 == page" :span="24/pmTable[key-1].length" :key="`${ind}${key}`">
                    <lida-table
                      :propscolumns="tableThead"
                      :data="arry"
                      :isSearch="false"
                      :LeaveSpace="false"
                      :FirstColMbStatus="false"
                      :sortStatus="false"
                      :page="false"
                      :SpinLoading="SpinLoading"
                      @on-selection-change="data => selectPlay(data, key-1, ind)"
                    >
                    </lida-table>
                  </Col>
                </template>
              </template>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
    <div slot="footer">
      <!-- <Checkbox :disabled="[0, 1].includes(tempId)" class="mr-3" v-model="changed">{{ "修改模板" }}</Checkbox> -->
      <Checkbox :disabled="tempId == 1" class="mr-3" v-model="defaultuse">{{ "设为预设模板" }}</Checkbox>
      <Button type="success" @click="sumitData()">{{ $t("lsib.confirm") }}</Button>
      <Button type="error" @click="modalshow=false">{{ $t("common.cancel") }}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import NP from 'number-precision';
import { ToDecimal, Utile } from 'utils';
export default {
  name: 'QuickOddChangeModal',
  data () {
    return {
      pmAry: [
        { title: this.$t("message.number")+this.$t("common.gameKind"), pmlist: [], pmcheck: [], indeterminate: false, checkAll: false},
        { title: this.$t("lsib.ShengShiau")+this.$t("common.gameKind"), pmlist: [], pmcheck: [], indeterminate: false, checkAll: false},
        { title: this.$t("lsib.WeiShu")+this.$t("common.gameKind"), pmlist: [], pmcheck: [], indeterminate: false, checkAll: false}
      ],
      pmTable: {
        0: [],
        1: []
      },
      newtempName: '',
      defaultuse: true,
      changed: false,
      scaleObj: {},
      selectItems: {},
      mod: 'zodiac',
      zodiac: [],
      selectAry: [],
      selectZodiac: [],
      selectNum: [],
      tail: [],
      selectTail: [],
      scale: 0,
      templist: [],
      tempId: 1,
      deletmpState: false,
      scaleState: false,
      modlist: {
        'twoside': [
          [
            { value: 'o', id: this.$t("lsib.Dan") },
            { value: 'e', id: this.$t("lsib.Shuang") },
            { value: 'po', id: this.$t("lsib.HeDan") },
            { value: 'pe', id: this.$t("lsib.HeShuang") }
          ],
          [ 
            { value: 'l', id: this.$t("lsib.Da") },
            { value: 's', id: this.$t("lsib.Shiau") },
            { value: 'tl', id: this.$t("lsib.WeiDa") },
            { value: 'ts', id: this.$t("lsib.WeiShiau") }
            
          ],
          [ 
            { value: 'r', id: this.$t("system.red") },
            { value: 'b', id: this.$t("system.blue") },
            { value: 'g', id: this.$t("system.green") }
          ]
        ],
        'zodiac': []
      },
      balls: [
        [
          { id: "01", value: 1, color: "red", focus: false },
          { id: "02", value: 2, color: "red", focus: false },
          { id: "03", value: 3, color: "blue", focus: false },
          { id: "04", value: 4, color: "blue", focus: false },
          { id: "05", value: 5, color: "green", focus: false },
          { id: "06", value: 6, color: "green", focus: false },
          { id: "07", value: 7, color: "red", focus: false },
          { id: "08", value: 8, color: "red", focus: false },
          { id: "09", value: 9, color: "blue", focus: false },
          { id: "10", value: 10, color: "blue", focus: false }
        ], [
          { id: "11", value: 11, color: "green", focus: false },
          { id: "12", value: 12, color: "red", focus: false },
          { id: "13", value: 13, color: "red", focus: false },
          { id: "14", value: 14, color: "blue", focus: false },
          { id: "15", value: 15, color: "blue", focus: false },
          { id: "16", value: 16, color: "green", focus: false },
          { id: "17", value: 17, color: "green", focus: false },
          { id: "18", value: 18, color: "red", focus: false },
          { id: "19", value: 19, color: "red", focus: false },
          { id: "20", value: 20, color: "blue", focus: false },
        ], [
          { id: "21", value: 21, color: "green", focus: false },
          { id: "22", value: 22, color: "green", focus: false },
          { id: "23", value: 23, color: "red", focus: false },
          { id: "24", value: 24, color: "red", focus: false },
          { id: "25", value: 25, color: "blue", focus: false },
          { id: "26", value: 26, color: "blue", focus: false },
          { id: "27", value: 27, color: "green", focus: false },
          { id: "28", value: 28, color: "green", focus: false },
          { id: "29", value: 29, color: "red", focus: false },
          { id: "30", value: 30, color: "red", focus: false },
        ], [
          { id: "31", value: 31, color: "blue", focus: false },
          { id: "32", value: 32, color: "green", focus: false },
          { id: "33", value: 33, color: "green", focus: false },
          { id: "34", value: 34, color: "red", focus: false },
          { id: "35", value: 35, color: "red", focus: false },
          { id: "36", value: 36, color: "blue", focus: false },
          { id: "37", value: 37, color: "blue", focus: false },
          { id: "38", value: 38, color: "green", focus: false },
          { id: "39", value: 39, color: "green", focus: false },
          { id: "40", value: 40, color: "red", focus: false },
        ], [
          { id: "41", value: 41, color: "blue", focus: false },
          { id: "42", value: 42, color: "blue", focus: false },
          { id: "43", value: 43, color: "green", focus: false },
          { id: "44", value: 44, color: "green", focus: false },
          { id: "45", value: 45, color: "red", focus: false },
          { id: "46", value: 46, color: "red", focus: false },
          { id: "47", value: 47, color: "blue", focus: false },
          { id: "48", value: 48, color: "blue", focus: false },
          { id: "49", value: 49, color: "green", focus: false },
        ]
      ],
      zodiacObj: {
        'pou': [],
        'bea': []
      },
      modalshow: false,
      page1: [1,2,3,12,14,15,16,10,55,13,113,11,4,5,6,7,8,17,117,18,118,19,119,20,120,21,121,22,122,23,123,57,157,24,25,26,27,28,29],
      page2: [30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51],
      page: 0,
      SpinLoading: false
    };
  },
  computed: {
    ...mapGetters(["getgameid", "getmember", "getliveshow"]),
    twosideObj () {
      let obj = {
        'o': [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35, 37, 39, 41, 43, 45, 47],
        'e': [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48],
        'po': [1, 3, 5, 7, 9, 10, 12, 14, 16, 18, 21, 23, 25, 27, 29, 30, 32, 34, 36, 38, 41, 43, 45, 47],
        'pe': [2, 4, 6, 8, 11, 13, 15, 17, 19, 20, 22, 24, 26, 28, 31, 33, 35, 37, 39, 40, 42, 44, 46, 48],
        'l': [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48],
        's': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
        'tl': [5, 6, 7, 8, 9, 15, 16, 17, 18, 19, 25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 45, 46, 47, 48],
        'ts': [1, 2, 3, 4, 10, 11, 12, 13, 14, 20, 21, 22, 23, 24, 30, 31, 32, 33, 34, 40, 41, 42, 43, 44],
        'r': [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46],
        'b': [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48],
        'g': [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49]
      }
      return obj
    },
    tableThead () {
      const arr = [
        {
          type: 'selection',
          width: 40,
          align: 'center'
        },
        {
          title: this.$t('common.gameKind'),
          key: 'pmname',
          align: 'center',
          width: 60,
        },
        {
          title: '原始' + this.$t('common.odds'),
          key: 'odds',
          align: 'center',
          width: 52,
          render: (h, params) => {
            if (params.row.odds == undefined) return ''
            if ((params.row.odds).toString().includes('/')) {
              let text = params.row.odds.split('/')
              return [h('p', text[0]+'/'), h('p', text[1])]
            }
            return h('p', params.row.odds)
          }
        },
        {
          title: '调整比例(%)',
          key: 'scale',
          align: 'center',
          width: 80,
          render: (h, params) => {
            let plus = h('img', {
              domProps: {
                src: 'https://i.imgur.com/cWUqqLH.gif'
              },
              style: {
                cursor: "pointer"
              },
              on: {
                click: () => {
                  if (params.row.scale == null) return
                  if (NP['plus'](params.row.scale, 1) >= 100 || NP['plus'](params.row.scale, 1) < 0) return
                  if (this.scaleState) return
                  this.scaleState = true
                  params.row.scale = NP['plus'](params.row.scale, 1)
                  let scale = NP.divide((NP.minus(100, params.row.scale)), 100)
                  if ((params.row.odds).toString().includes('/')) {
                    let text = params.row.odds.split('/')
                    text[0] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[0]), scale))
                      : ToDecimal(NP.times(Number(text[0]), scale), 3)
                    text[1] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[1]), scale))
                      : ToDecimal(NP.times(Number(text[1]), scale), 3)
                    params.row.scOdds = `${text[0]} / ${text[1]}`
                  } else {
                    params.row.scOdds = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(params.row.odds), scale))
                      : ToDecimal(NP.times(Number(params.row.odds), scale), 3)
                  }
                  this.scaleObj[params.row.oddid] = scale
                  setTimeout(() => {
                    this.scaleState = false
                  }, 500);
                }
              }
            })
            let minus = h('img', {
              domProps: {
                src: 'https://i.imgur.com/04cGLwd.gif'
              },
              style: {
                cursor: "pointer"
              },
              on: {
                click: () => {
                  if (params.row.scale == null) return
                  if (NP['minus'](params.row.scale, 1) >= 100 || NP['minus'](params.row.scale, 1) < 0) return
                  if (this.scaleState) return
                  this.scaleState = true
                  params.row.scale = NP['minus'](params.row.scale, 1)
                  let scale = NP.divide((NP.minus(100, params.row.scale)), 100)
                  if ((params.row.odds).toString().includes('/')) {
                    let text = params.row.odds.split('/')
                    text[0] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[0]), scale))
                      : ToDecimal(NP.times(Number(text[0]), scale), 3)
                    text[1] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[1]), scale))
                      : ToDecimal(NP.times(Number(text[1]), scale), 3)
                    params.row.scOdds = `${text[0]} / ${text[1]}`
                  } else {
                    params.row.scOdds = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(params.row.odds), scale))
                      : ToDecimal(NP.times(Number(params.row.odds), scale), 3)
                  }
                  this.scaleObj[params.row.oddid] = scale
                  setTimeout(() => {
                    this.scaleState = false
                  }, 500);
                }
              }
            })
            let input = h('InputNumber', {
              props: {
                value: Number(params.row.scale),
                step: 1,
                min: 0,
                max: 99,
                align: "center"
              },
              style: {
                width: "60px",
                margin: "0 2px"
              },
              on: {
                'on-change': (val) => {
                  params.row.scale = val
                  let scale = NP.divide((NP.minus(100, val)), 100)
                  if ((params.row.odds).toString().includes('/')) {
                    let text = params.row.odds.split('/')
                    text[0] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[0]), scale))
                      : ToDecimal(NP.times(Number(text[0]), scale), 3)
                    text[1] = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(text[1]), scale))
                      : ToDecimal(NP.times(Number(text[1]), scale), 3)
                    params.row.scOdds = `${text[0]} / ${text[1]}`
                  } else {
                    params.row.scOdds = [5, 8].includes(params.row.oddid)
                      ? Math.floor(NP.times(Number(params.row.odds), scale))
                      : ToDecimal(NP.times(Number(params.row.odds), scale), 3)
                  }
                  this.scaleObj[params.row.oddid] = scale
                }
              }
            })

            return params.row.oddid 
              ? h('div', { style: { 'display': "flex", 'align-items': "center", 'justify-content': "center" } }, [plus, input, minus])
              : ''
          }
        },
        {
          title: '调整后' + this.$t('common.odds'),
          key: 'scOdds',
          align: 'center',
          width: 57,
          render: (h, params) => {
            if (params.row.scOdds == undefined) return ''
            if ((params.row.scOdds).toString().includes('/')) {
              let text = params.row.scOdds.split('/')
              return [h('p', text[0]+'/'), h('p', text[1])]
            }
            return h('p', params.row.scOdds)
          }
        }
      ]

      return arr
    }
  },
  watch: {
    mod () {
      this.selectAry = []
      this.judgeSelectAry()
    },
    modalshow (modalshow) {
      if (!modalshow) {
        this.clearAllBtn()
        this.scale = 0
        this.mod = 'zodiac'
        this.tail = []
        for (let index = 0; index < this.pmAry.length; index++) {
          this.pmAry[index].pmlist = []
          this.pmAry[index].pmcheck = []
          this.pmAry[index].indeterminate = false
          this.pmAry[index].checkAll = false
        }
      }
    }
  },
  mounted () {
    this.$Eventhub.$on("quick-odds-changes-modal", pre => {
      this.modalshow = true;
      this.getPlayList()
    });
  },
  methods: {
    ...mapMutations(['upDateReload']),
    async getPlayList () {
      try {
        this.SpinLoading = true
        const zodiaclist = await this.$axios.liveshow.yzodod()
        this.zodiac = zodiaclist.reduce((ary, item, ind) => {
          const index = ind % 5
          const obj = {
            id: item.zodiac,
            value: item.yzorder,
            focus: false
          }
          ary.length = 5
          if (ary[index] == undefined) ary[index] = []
          ary[index].push(obj)
          return ary
        }, [])
        this.modlist['zodiac'] = zodiaclist.reduce((ary, item, ind) => {
          const index = parseInt(ind / 2)
          const obj = {
            id: item.zodiac,
            value: item.yzorder
          }
          ary.length = 6

          if (ary[index] == undefined) ary[index] = []
          ary[index].push(obj)
          return ary
        }, [])
        this.modlist['zodiac'].push(
          [
            { value: 'pou', id: this.$t("lsib.poultry") },
            { value: 'bea', id: this.$t("lsib.beast") }
          ]
        )
        zodiaclist.forEach(item => {
          const numAry = item.number.split(',').map(num => Number(num))
          this.zodiacObj[item.yzorder] = numAry
          if ([2,7,8,10,11,12].includes(item.yzorder)) this.zodiacObj['pou'] = [...this.zodiacObj['pou'], ...numAry]
          if ([1,3,4,5,6,9].includes(item.yzorder)) this.zodiacObj['bea'] = [...this.zodiacObj['bea'], ...numAry]
        })

        for (let i = 0; i < 10; i++) {
          let groupIndex = (i % 5)
          let pairValue = i + 1 == 10 ? 0 : i + 1
          if (!this.tail[groupIndex]) this.tail[groupIndex] = []
          this.tail[groupIndex].push({
            id: pairValue + '尾',
            value: pairValue,
            focus: false
          });
        }
        const res = await this.$axios.liveshow.jumpTimeData(this.getgameid)
        const temp = await this.$axios.liveshow.quickoddsmodel()
        let deftemp = [
          {
            name: "普通模式",
            modid: 1,
            jsondata: '[]'
          },
          {
            name: "新增比例模板",
            modid: 0,
            jsondata: '[]'
          }
        ]
        this.templist = temp
        
        this.templist.push(...deftemp)
        this.tempId = temp[0].modid
        const table = [...res['pmlist1']].map(item => {
          let scale = JSON.parse(temp[0].jsondata).length > 0 && JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid) 
            ? JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid).scale 
            : 0
          let use = JSON.parse(temp[0].jsondata).length > 0 && JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid) 
            ? JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid).use 
            : 0
          let scOdds = item.odds
          if (scale !== 0) {
            if ((item.odds).toString().includes('/')) {
              let text = item.odds.split('/')
              text[0] = [5, 8].includes(item.oddid)
                ? Math.floor(NP.times(Number(text[0]), scale))
                : ToDecimal(NP.times(Number(text[0]), scale), 3)
              text[1] = [5, 8].includes(item.oddid)
                ? Math.floor(NP.times(Number(text[1]), scale))
                : ToDecimal(NP.times(Number(text[1]), scale), 3)
              scOdds = `${text[0]} / ${text[1]}`
            } else {
              scOdds = [5, 8].includes(item.oddid)
                ? Math.floor(NP.times(Number(item.odds), scale))
                : ToDecimal(NP.times(Number(item.odds), scale), 3)
            }
          }
          if (use == 1 || scale !== 0) {
            this.scaleObj[item.oddid] = scale
          }

          return {
            ...item,
            scale: scale == 0 || scale == undefined ? 0 : NP.times((NP.minus(1, scale)), 100),
            scOdds,
            _checked: use == 1
          }
        })
        let P1 = table.filter(item => this.page1.includes(item.oddid))
        let P2 = table.filter(item => this.page2.includes(item.oddid))
        let all = [P1, P2]
        all.forEach((ary, ind) => {
          // if (ary.length % 3 !== 0) {
            let length = ary.length < 34
              ? 33 - ary.length
              : (ary.length % 3) + 1

            for (let index = 0; index < length; index++) {
              if (ind == 0 && index == 0) {
                const loc = ary.findIndex(item => item.oddid == 13)
                ary.splice(loc, 0, ...[{ _disabled: true, _checked: false }, { _disabled: true, _checked: false }])

                const loc2 = ary.findIndex(item => item.oddid == 21)
                ary.splice(loc2, 0, { _disabled: true, _checked: false })
              } else {
                ary.push({ _disabled: true, _checked: false })
              }
            }
          // }

          this.pmTable[ind] = Utile.chunk(ary, (ary.length / 3))
        })

        Object.keys(this.pmTable).forEach(key => {
          this.selectItems[key] = []
          this.pmTable[key].forEach((arry, index) => {
            this.selectItems[key][index] = []
            arry.forEach(item => {
              let use = JSON.parse(temp[0].jsondata).length > 0 && JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid)
                ? JSON.parse(temp[0].jsondata).find(it => it.oddid == item.oddid).use
                : 0
              if (use == 1) this.selectItems[key][index].push({ oddid: item.oddid })
            })
          })
        })
        this.defaultuse = this.tempId !== 1
      } catch (error) {
        console.error(error)
      } finally {
        this.SpinLoading = false
      }
    },
    numSelect (numVal) {
      if (this.selectNum.includes(numVal)) {
        this.selectNum = this.selectNum.filter(it => it !== numVal)
      } else {
        this.selectNum.push(numVal)
      }

      this.judgeSelectAry()
    },
    zodiacSelect (zodiacVal, isFocus) {
      if (this.selectAry.includes(zodiacVal)) return
      if (this.selectZodiac.includes(zodiacVal)) {
        this.selectZodiac = this.selectZodiac.filter(it => it !== zodiacVal)
      } else {
        this.selectZodiac.push(zodiacVal)
      }
    },
    tailSelect (tailVal) {
      if (this.selectTail.includes(tailVal)) {
        this.selectTail = this.selectTail.filter(it => it !== tailVal)
      } else {
        this.selectTail.push(tailVal)
      }

      this.$forceUpdate()
    },
    modCheckboxChange (e) {
      let modNum = []
      this.selectAry.forEach(key => {
        const ObjName = typeof key == 'number' || ['pou', 'bea'].includes(key)
          ? 'zodiacObj'
          : 'twosideObj'
        modNum = [...modNum, ...this[ObjName][key]]
      })
      this.selectNum = this.selectNum.filter(num => !modNum.includes(num))

      this.balls.forEach(ary => {
        ary.forEach(item => {
          item.focus = false
          if (modNum.includes(item.value) || this.selectNum.includes(item.value)) item.focus = true
        })
      })

      if (this.mod == 'zodiac') {
        let zodValue = []
        this.selectAry.forEach(num => {
          if (num == 'pou') zodValue = [...zodValue, ...[2,7,8,10,11,12]]
          else if (num == 'bea') zodValue = [...zodValue, ...[1,3,4,5,6,9]]
          else zodValue = [...zodValue, num]
        })
        this.zodiac.forEach(ary => {
          ary.forEach(item => {
            item.focus = false
            if (zodValue.includes(item.value) || this.selectZodiac.includes(item.value)) item.focus = true
            if (zodValue.includes(item.value) && this.selectZodiac.includes(item.value)) this.selectZodiac = this.selectZodiac.filter( num=> num!== item.value)
          })
        })
      }
    },
    judgeSelectAry () {
      let focusNum = []
      this.balls.forEach(ary => {
        ary.forEach(item => {
          if (item.focus) focusNum.push(item.value)
        })
      })
      const ObjName = `${this.mod}Obj`
      Object.keys(this[ObjName]).forEach(key => {
        const newkey = Number(key) ? Number(key):key
        if (this[ObjName][key].filter(num => !focusNum.includes(num)).length == 0) {
          if (!this.selectAry.includes(newkey)) {
            this.selectAry.push(newkey)
          }
        } else this.selectAry = this.selectAry.filter(it => it !== newkey)
      })

      // if (this.mod == 'twoside') {
      //   this.zodiac.forEach(ary => {
      //     ary.forEach(item => {
      //       item.focus = false
      //       if (this.selectZodiac.includes(item.value)) item.focus = true
      //     })
      //   })
      // }
      // if (this.mod == 'zodiac') this.modCheckboxChange()
    },
    changScale (text) {
      if (this.scale == null) return
      if (NP[text](this.scale, 20) >= 100 || NP[text](this.scale, 20) < 0) return
      this.scale = NP[text](this.scale, 20)
    },
    setTempData () {
      this.newtempName = ''
      this.selectItems = {}
      this.scaleObj = {}

      if ([0, 1].includes(this.tempId)) {
        Object.keys(this.pmTable).forEach(key => {
          this.selectItems[key] = []
          this.pmTable[key] = this.pmTable[key].map((arry, ind) => {
            this.selectItems[key][ind] = []
            arry = arry.map(item => {
              if (!item.pmname) return item
              return {
                ...item,
                scale: 0,
                _checked: false,
                scOdds: item.odds
              }
            })
            return arry
          })
        })
      } else {
        let temp = JSON.parse(this.templist.find(item => item.modid == this.tempId).jsondata)
        Object.keys(this.pmTable).forEach(key => {
          this.selectItems[key] = []
          this.pmTable[key].forEach((arry, index) => {
            this.selectItems[key][index] = []
            arry.forEach(item => {
              if (!item.pmname) return item
              let newItem = temp.find(it => it.oddid == item.oddid)
              item.scale = newItem.scale == 0 ? 0 : NP.times((NP.minus(1, newItem.scale)), 100)
              item._checked = newItem.use == 1
              let scOdds = item.odds
              if ((item.odds).toString().includes('/')) {
                let text = item.odds.split('/')
                text[0] = [5, 8].includes(item.oddid)
                  ? Math.floor(NP.times(Number(text[0]), newItem.scale))
                  : ToDecimal(NP.times(Number(text[0]), newItem.scale), 3)
                text[1] = [5, 8].includes(item.oddid)
                  ? Math.floor(NP.times(Number(text[1]), newItem.scale))
                  : ToDecimal(NP.times(Number(text[1]), newItem.scale), 3)
                scOdds = `${text[0]} / ${text[1]}`
              } else {
                scOdds = [5, 8].includes(item.oddid)
                  ? Math.floor(NP.times(Number(item.odds), newItem.scale))
                  : ToDecimal(NP.times(Number(item.odds), newItem.scale), 3)
              }
              item.scOdds = newItem.scale == 0 ? item.odds : scOdds

              if (newItem.use == 1) {
                this.selectItems[key][index].push({ oddid: item.oddid })
                this.scaleObj[item.oddid] = newItem.scale
              }
              if (newItem.scale !== 0) {
                this.scaleObj[item.oddid] = newItem.scale
              }
            })
          })
        })
      }
      this.defaultuse = this.tempId !== 1
    },
    async savetemp () {
      if (this.deletmpState) return
      this.deletmpState = true

      try {
        if (this.tempId == 0 && this.newtempName == '') return this.$Message.error(this.$t('请输入新模板名称'))

        let data = {}
        let jsondata = []
        let selectItems = [...this.selectItems[0], ...this.selectItems[1]].flat().map(item => item.oddid)
        Object.keys(this.pmTable).forEach(key => {
          this.pmTable[key].forEach(arr => {
            arr.forEach(item => {
              if (!item.pmname) return
              jsondata.push({
                'use': selectItems.includes(item.oddid) ?  1: 0,
                'oddid': item.oddid,
                'scale': this.scaleObj[item.oddid] ? this.scaleObj[item.oddid] : item.scale
              })
            })
          })
        })    
        
        if (this.tempId == 0) {
          data = {
            loid: this.getmember.pid,
            name: this.newtempName,
            defaultuse: this.defaultuse ? 1 : 0,
            jsondata
          }
        } else {
          data = {
            loid: this.getmember.pid,
            modid: this.tempId,
            defaultuse: this.defaultuse ? 1 : 0,
            status: 1,
            jsondata
          }
        }

        const res = this.tempId == 0 
          ? await this.$axios.liveshow.addquickoddsmodel(data)
          : await this.$axios.liveshow.updquickoddsmodel(data)

        if (res.status == 1) {
          this.$Message.success(this.$t("front.save")+this.$t("message.success"));
          this.tail = []
          this.page = 0
          this.getPlayList()
        }
        
      } catch (error) {
        this.$Message.error(this.$t("front.save")+this.$t("message.failure"))
        console.error(error)
      } finally {
        setTimeout(() => {
          this.deletmpState = false
        }, 500);
      }
    },
    async deletemp () {
      if (this.deletmpState) return
      this.deletmpState = true

      try {
        let data = {
          loid: this.getmember.pid,
          modid: this.tempId,
          status: 0,
          jsondata: "[]",
          defaultuse: 0
        }

        const res = await this.$axios.liveshow.updquickoddsmodel(data)

        if (res.status == 1) {
          this.$Message.success(this.$t("message.delectOk"));
          this.templist = this.templist.filter(item => item.modid !== this.tempId)
          this.tempId = this.templist[0].modid
          this.page = 0
          this.setTempData()
        }
      } catch (error) {
        this.$Message.error(this.$t("message.delectFail"))
        console.error(error)
      } finally {
        setTimeout(() => {
          this.deletmpState = false
        }, 500);
      }
    },
    selectPlay (data, key, ind) {
      let selectId = data.map(item => item.indexNumber)
      this.selectItems[key][ind] = this.pmTable[key][ind].filter(item => selectId.includes(item.indexNumber)).map(item => {
        return {
          oddid: item.oddid
        }
      })
    },
    async sumitData () {
      try {
        let pmidlist = []
        pmidlist.sort((a, b) => Number(a) - Number(b))
        let marklist = []
        this.balls.forEach(ary => {
          ary.forEach(item => {
            if (item.focus) marklist.push(item.value)
          })
        })
        marklist.sort((a, b) => Number(a) - Number(b))
        let yzolist = []
        this.zodiac.forEach(ary => {
          ary.forEach(item => {
            if (item.focus) yzolist.push(item.value)
          })
        })
        yzolist.sort((a, b) => Number(a) - Number(b))
        let taillist = []
        this.tail.forEach(ary => {
          ary.forEach(item => {
            if (item.focus) taillist.push(item.value)
          })
        })
        taillist.sort((a, b) => Number(a) - Number(b))

        if ([...this.selectItems[0], ...this.selectItems[1]].flat().length == 0) return this.$Message.error(this.$t('请选择玩法'))
        if ((marklist.length == 0 && yzolist.length == 0) && taillist.length == 0) return this.$Message.error(this.$t('请选择号码或生肖或尾数'))
        
        let data = {
          loid: this.getmember.pid,
          gameid: this.getgameid,
          marklist: marklist.toString(),
          yzolist: yzolist.toString(),
          taillist: taillist.toString(),
          stid: this.getliveshow.siteSelect
        }

        let oddidArr = [...this.selectItems[0], ...this.selectItems[1]].flat().map(item => {
          return {
            ...item,
            scale: this.scaleObj[item.oddid] ? this.scaleObj[item.oddid] : 1
          }
        })

        data['oddidArr'] = oddidArr

        const res = await this.$axios.liveshow.quickoddsplay(data)

        if (res.status == 1) {
          this.$Eventhub.$emit('liveshow-refresh')
          let jsondata = []
          let selectItems = [...this.selectItems[0], ...this.selectItems[1]].flat().map(item => item.oddid)
          Object.keys(this.pmTable).forEach(key => {
            this.pmTable[key].forEach(arr => {
              arr.forEach(item => {
                if (!item.pmname) return
                jsondata.push({
                  'use': selectItems.includes(item.oddid) ?  1: 0,
                  'oddid': item.oddid,
                  'scale': this.scaleObj[item.oddid] ? this.scaleObj[item.oddid] : item.scale
                })
              })
            })
          })
          if (this.tempId != 0) {
            let data = {
              loid: this.getmember.pid,
              modid: this.tempId,
              defaultuse: this.defaultuse ? 1 : 0,
            }

            const res = await this.$axios.liveshow.updquickoddsmodel(data)
          }
          if (res.status == 1) this.$Message.success(this.$t("message.modifyOk"));
          this.modalshow = false
        }
      } catch (error) {
        console.error(error)
      }
    },
    checkAll (e, index, key, chekKey) {
      if (e) this.pmAry[index][chekKey] = this.pmAry[index][key].map(item => item.oddid)
      else this.pmAry[index][chekKey] = []
      this.pmAry[index].checkAll = e
      this.checkAllGroupChange (this.pmAry[index][chekKey], index)
    },
    checkAllGroupChange (data, index) {
      if (data.length === this.pmAry[index]['pmlist'].length) {
        this.pmAry[index].indeterminate = false;
        this.pmAry[index].checkAll = true;
      } else if (data.length > 0) {
        this.pmAry[index].indeterminate = true;
        this.pmAry[index].checkAll = false;
      } else {
        this.pmAry[index].indeterminate = false;
        this.pmAry[index].checkAll = false;
      }
    },
    selectAllBtn () {
      this.zodiac.forEach(ary => {
        ary.forEach(item => {
          item.focus = true
        })
      })

      this.balls.forEach(ary => {
        ary.forEach(item => {
          item.focus = true
        })
      })

      this.tail.forEach(ary => {
        ary.forEach(item => {
          item.focus = true
        })
      })
    },
    clearAllBtn () {
      this.zodiac.forEach(ary => {
        ary.forEach(item => {
          item.focus = false
        })
      })

      this.balls.forEach(ary => {
        ary.forEach(item => {
          item.focus = false
        })
      })

      this.tail.forEach(ary => {
        ary.forEach(item => {
          item.focus = false
        })
      })

      this.selectAry = []
      this.selectZodiac = []
      this.selectNum = []
      this.selectItems = {}
      this.scaleObj = {}
      this.tempId = 1
      this.newtempName = ''
      this.defaultuse = true
      this.changed = false
      this.page = 0

      this.setTempData()
    }
  }
}
</script>
<style lang="scss">
.quickModal {
  .ivu-modal {
    top: 50px
  }
  .ivu-modal-body {
    position: relative;

  }
  .ivu-modal-footer{
    padding-top: 0;
    border-top: 0;
    text-align: center;
  }
}
.modalbody {
  display: flex;
  border: 1px solid #ccc;
  font-size: 14px;
  letter-spacing: 1px;
  .ivu-checkbox {
    margin-right: 3px;
  }
  .numArea {
    border-right: 1px solid #ccc;
    padding: 4px;
    .numbutton {
      width: 28px;
      height: 28px;
      line-height: 24px;
      margin: 2px 0;
      padding-top: 2px;
      box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
      border: 1px solid #ccc;
      background: linear-gradient(to bottom, #ffffff 0%,#ebebeb 50%,#d8d8d8 100%);
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: linear-gradient(to bottom, #ffff9bd5 0%, #ffff3aef 50%, #ffff00 100%);
      }
      &.focus {
        background: linear-gradient(to bottom, #ffff9bd5 0%, #ffff3aef 50%, #ffff00 100%);
      }
    }
  }
  .btnArea,
  .rightbtnArea,
  .pmcheck {
    padding: 4px;
    border-bottom: 1px solid #ccc;
  }
  .rightbtnArea {
    display: flex;
    justify-content: space-between;
    height: 33px;
  }
  .btnArea {
    width: 100%;
    border-right: 1px solid #ccc;
  }
  .modArea {
    padding: 4px;
    .modCheckboxGroup {
      display: inline-block;
      .ivu-checkbox-wrapper {
        margin-right: 5px;
        width: 52px;
      }
    }
  }
  .tableArea {
    td {
      height: 44px;
    }
  }
}
.col-xs-15 {
  position: relative;
  width: 20%;
  float: left;
  min-height: 1px;
  padding-right: 2px;
  padding-left: 2px;
}
.dark-text {
  color: black;
}
.grey-text {
  color: #ccc;
}
</style>
